import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Icon from "./icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useMenuCollapseSelector } from "../store/selectors/loaderSelector";
import GradientBGContainer from "./gradientBgContainer";
import { useUserSelector } from "../store/selectors/userSelector";
import Profile from "./profile";
import LanguageSwitcher from "./LanguageSwitcher";
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: any;
    className?: string;
}

const Header: React.FC<Props> = ({ children, className = "" }) => {
    const { t } = useTranslation("common");
    return (
        <header className={"sticky top-0 z-[100]" + className}>
            <GradientBGContainer className="h-[90px] px-[30px] py-[15px] flex items-center justify-end">
                {/* Left: Search box */}
                {/* <div className="flex items-center bg-white rounded-md overflow-hidden shadow w-[754px] h-[50px] p-[10px]">
                    <button className="bg-secondary text-white p-2 text-sm font-medium ">Move To</button>
                    <input
                        type="text"
                        placeholder="Type Desired Menu"
                        className="text-black px-3 py-2 outline-none text-sm"
                    />
                </div> */}

                {/* Right: Help, Notification, Profile */}
                <div className="flex items-center gap-12 text-white">
                    {/* Language switcher */}
                    <LanguageSwitcher className="w-48" />

                    {/* Help link */}
                    <button className="text-md hover:underline">{t("header.help")}</button>

                    {/* Notification icon */}
                    <button className="relative">
                        <Icon name="bell" size={28} />
                        {/* Example notification dot */}
                        <span className="absolute -top-1 -right-1 bg-red-500 rounded-full w-2 h-2"></span>
                    </button>

                    {/* Profile */}
                    <Profile />
                </div>
            </GradientBGContainer>
        </header>
    );
};

export default Header;
